import { dataVideoFrameFirst } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoFrameFirst = /*#__PURE__*/createIcon(dataVideoFrameFirst)
export default IconVideoFrameFirst
